import type { CSSProperties } from 'react';
import type { Video } from '../lib/types';

type Props = {
  video: Pick<Video, 'tint' | 'thumbUrl' | 'duration' | 'progress' | 'title'>;
  radius?: number;
  width?: number | string;
  showLabel?: boolean;
  showDuration?: boolean;
  showProgress?: boolean;
  style?: CSSProperties;
  onClick?: () => void;
};

// アプリ全体のサムネ表示ユニット。thumbUrl があれば <img>、なければ色付きの
// 「サムネイル」プレースホルダを出す。動画長・視聴進捗のオーバーレイも共通化。
export function Thumb({
  video,
  radius = 12,
  width,
  showLabel = true,
  showDuration = true,
  showProgress = true,
  style,
  onClick,
}: Props): JSX.Element {
  const hasImage = !!video.thumbUrl;
  const wrap: CSSProperties = {
    position: 'relative',
    aspectRatio: '16 / 9',
    borderRadius: radius,
    overflow: 'hidden',
    display: 'grid',
    placeItems: 'center',
    background: hasImage ? 'var(--ink-strong)' : video.tint,
    width,
    cursor: onClick ? 'pointer' : undefined,
    ...style,
  };

  return (
    <div style={wrap} onClick={onClick}>
      {hasImage ? (
        <img
          src={video.thumbUrl}
          alt={video.title ?? ''}
          loading="lazy"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      ) : (
        showLabel && (
          <span style={{ color: 'rgba(255,255,255,0.78)', fontSize: 11.5, letterSpacing: '0.08em' }}>
            サムネイル
          </span>
        )
      )}
      {showDuration && video.duration && (
        <span
          style={{
            position: 'absolute',
            right: 7,
            bottom: 7,
            background: 'rgba(0,0,0,0.62)',
            color: '#fff',
            fontSize: 10.5,
            padding: '2px 6px',
            borderRadius: 5,
          }}
        >
          {video.duration}
        </span>
      )}
      {showProgress && video.progress && video.progress !== '0%' && (
        <span
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: 3,
            background: 'rgba(255,255,255,0.3)',
          }}
        >
          <span style={{ display: 'block', height: 3, background: 'var(--brand)', width: video.progress }} />
        </span>
      )}
    </div>
  );
}
